
<span id="{{Id}}" *ngIf="html" [innerHTML]="html | safeHtml"></span>
